import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  InOut,
} from "../../model/model";

import InOutForm from "./InOutForm";
import SessionStore from "../../model/SessionStore";
import DeleteConfirm from "../../components/DeleteConfirm";
import { Button, Space, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";


function EditInOut() {
    const { ioId } = useParams();
    const [inOut, setInOut] = useState<InOut | undefined>(undefined);
    const [messageApi, contextHolder] = message.useMessage();
  
    const navigate = useNavigate();

  useEffect(() => {
    SessionStore.getClient().getInOut(ioId!, SessionStore.getBearer()).then((resp) => {
      setInOut(resp.data);
    });
  }, [ioId]);

  const onFinish = (obj: InOut) => {
    SessionStore.getClient().updateInOut(obj, SessionStore.getBearer()).then(() => {
      navigate(`/ios`);
    });
  };

  const deleteInOut = () => {
    if (!inOut) return;
    SessionStore.getClient().removeInOut(inOut.id, SessionStore.getBearer()).then(() => {
      messageApi.success("Integration deleted");
      navigate(`/ios`);
    }).catch(err => {
      if (err.status === 401) {
        navigate(`/login`);
      } else {
        messageApi.open({
          type: 'error',
          content: err.message,
        });
      }
    });
  };

  if (!inOut) {
    return null;
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      {contextHolder}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <DeleteConfirm confirm={inOut.name} typ="integration" onConfirm={deleteInOut}>
          <Button danger icon={<DeleteOutlined />}>
            Delete integration
          </Button>
        </DeleteConfirm>
      </div>
      <InOutForm initialValues={inOut} onFinish={onFinish} update/>
    </Space>
  );
}

export default EditInOut;
